const TRAFFIC_STORAGE_KEY = 'trafficInfo';
const VALID_TRAFFIC_TYPES = ['organic', 'paid'];

function getTrafficTypeFromRequestVariables() {
  const trafficType = window.requestVariables && window.requestVariables.traffic_type;

  if (VALID_TRAFFIC_TYPES.includes(trafficType)) {
    return trafficType;
  }

  return 'organic';
}

export function captureTrafficAttribution() {
  const traffic_type = getTrafficTypeFromRequestVariables();
  const trafficInfo = { traffic_type };

  sessionStorage.setItem(TRAFFIC_STORAGE_KEY, JSON.stringify(trafficInfo));

  return trafficInfo;
}

export function getTrafficFields() {
  const storedInfo = sessionStorage.getItem(TRAFFIC_STORAGE_KEY);

  if (storedInfo) {
    return JSON.parse(storedInfo);
  }

  return captureTrafficAttribution();
}
